// extracted by css-extract-rspack-plugin
export default {"cls1":"Filter-cls1_reE","cls2":"Filter-cls2_Ml4 Filter-cls1_reE","selected":"Filter-selected_vkV"};